var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/react-toastr/~/lodash/_Symbol.js
// module id = 39
// module chunks = 0